<script setup lang="ts">
import { ref } from 'vue'
import { useRouter, RouterLink } from 'vue-router'
import { useAppMode } from '@/composables/useAppMode'
import ArrowLeft from '@/assets/icons/arrow-left.svg'
import UiButton from '@/components/ui/button/Button.vue'
import Typography from '@/components/ui/typography/Typography.vue'
import PlusSvg from '@/assets/plus.svg'
import DrillsList from '@/components/drills/DrillsList.vue'
import { GameFlavor } from '@acepoker/contract'

const props = defineProps<{
  path: string
  flavors: GameFlavor[]
}>()

const router = useRouter()
const { mode } = useAppMode()

const DrillsListRef = ref()
</script>

<template>
    <div class="flex flex-col w-full h-full gap-4">
      <div v-if="mode === 'mobile'" class="flex flex-row w-full items-center gap-2 py-1">
        <UiButton class="bg-transparent w-[30px] h-[30px] p-0" @click="router.push('/games')"
          ><ArrowLeft class="w-[9px] h-[15px]"
        /></UiButton>
        <Typography class="font-semibold text-[22px] lg:text-[18px] grow">{{
          $t('NLHDrillsPage.label.NLHE')
        }}</Typography>

        <RouterLink
          v-if="DrillsListRef?.drillsType === 'custom'"
          :to="{ path: `/games/${props.path}/new` }"
          class="w-[30px] h-[30px]"
        >
          <PlusSvg />
        </RouterLink>
      </div>

      <div class="w-full h-[calc(100%-64px)] lg:h-full">
        <DrillsList ref="DrillsListRef" :path="props.path" :flavors="props.flavors" />
      </div>
    </div>
</template>

<style></style>
